export default function TermsPage() {
  return (
    <div className="min-h-screen bg-stone-50 pt-24 pb-16">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-stone-800 mb-2">이용약관</h1>
        <p className="text-stone-500 mb-8">최종 수정일: 2026년 5월 18일</p>
        <div className="bg-white rounded-xl border border-stone-200 p-6 space-y-6 text-sm text-stone-700 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제1조 (목적)</h2>
            <p>이 약관은 New Coupling(이하 "회사")이 제공하는 매칭 플랫폼 서비스(이하 "서비스")의 이용조건 및 절차, 회사와 회원 간의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제2조 (용어의 정의)</h2>
            <p>1. "회원"이란 회사와 서비스 이용 계약을 체결하고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</p>
            <p>2. "정회원"이란 신원·결혼이력 확인을 마치고 매칭 서비스에 참여 가능한 회원을 말합니다.</p>
            <p>3. "VIP 회원"이란 유료 결제를 통해 프리미엄 매칭·상담 서비스를 추가로 이용할 수 있는 회원을 말합니다.</p>
            <p>4. "콘텐츠"란 회원이 서비스 내에 게시한 글·사진·영상 등 모든 형태의 정보를 말합니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제3조 (서비스의 제공)</h2>
            <p>회사는 다음과 같은 서비스를 제공합니다:</p>
            <p>1. 커뮤니티 게시판 서비스</p>
            <p>2. AI 기반 이성 매칭 서비스</p>
            <p>3. 매칭&디너 / 소모임 / 파티 / 캠프 등 오프라인 이벤트</p>
            <p>4. 1:1·그룹 상담 서비스 및 줌데이트</p>
            <p>5. 연애사관학교 교육 콘텐츠 서비스</p>
            <p>6. 재혼·사별 회원을 위한 전용 매칭 및 콘텐츠</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제4조 (회원 가입 및 자격)</h2>
            <p>1. 회원가입은 <strong>만 19세 이상의 성인</strong>(미혼·이혼·사별·재혼 희망 한인 포함)을 대상으로 합니다.</p>
            <p>2. 회원은 가입 시 본 약관·개인정보 처리방침·결제 및 환불 약관에 동의해야 하며, 만 19세 이상임을 확인해야 합니다.</p>
            <p>3. 허위 정보를 기재하여 가입한 경우 회사는 서비스 이용을 제한하거나 계정을 삭제할 수 있습니다.</p>
            <p>4. 정회원 승급 시 혼인관계증명서 등 본인 확인 서류 제출이 요구될 수 있으며, 회사는 심사 완료 후 원본을 즉시 삭제합니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제5조 (결제 및 환불)</h2>
            <p>1. 유료 멤버십(정회원·VIP) 및 이벤트 참가비, 1:1 상담 비용은 Stripe를 통한 신용카드 결제 또는 회사가 별도로 지정한 결제 수단으로 결제할 수 있습니다.</p>
            <p>2. <strong>유료 멤버십(1년 단위)</strong>은 결제일로부터 <strong>1년간 이용 가능한 연간 멤버십</strong>으로 구성되며, 만료 전 회원이 별도로 <strong>해지(캔슬)하지 않는 한 동일 조건·동일 금액으로 자동 결제·자동 연장</strong>됩니다. 해지는 마이페이지에서 언제든 가능합니다.</p>
            <p>3. <strong>청약철회 및 환불 기준:</strong> 전자상거래법에 따라 결제일로부터 7일 이내이며 유료 서비스를 사용하지 않은 경우 전액 환불됩니다. 콘텐츠 열람·매칭 추천 수령·상담 진행 등 서비스가 일부라도 제공된 경우에는 잔여 기간에 대한 일할 계산 후 환불됩니다.</p>
            <p>4. <strong>이벤트·오프라인 모임 환불:</strong> 이벤트 시작 7일 전 전액 환불 / 3~6일 전 50% 환불 / 2일 이내·노쇼 환불 불가. 천재지변 등 회사 사정으로 취소되는 경우 전액 환불됩니다.</p>
            <p>5. <strong>환불 절차:</strong> 고객센터(contact@newcoupling.com)로 요청해주시면 영업일 기준 3~7일 이내에 결제 수단으로 환불됩니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제6조 (프로필 공개 동의 및 노출 관리)</h2>
            <p>1. 회사는 회원이 가입 시 <strong>"내 프로필을 회원정보보기에 공개"</strong> 선택 동의를 받습니다. 동의하지 않은 회원의 프로필은 회원정보보기 목록에서 비공개 처리됩니다.</p>
            <p>2. 회원은 마이페이지의 <strong>"회원정보보기 노출 ON/OFF"</strong> 스위치를 통해 언제든 공개 여부를 변경할 수 있습니다.</p>
            <p>3. 회사는 운영상 필요(부정 이용·신고 처리·휴면 관리 등)에 따라 회원의 프로필을 일시 비공개 처리할 수 있으며, 이 경우 회원이 다음 로그인 시 다시 노출 여부를 선택할 수 있도록 안내합니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제7조 (금지 행위)</h2>
            <p>회원은 다음 행위를 해서는 안 됩니다:</p>
            <p>1. 허위 정보 기재 또는 타인의 정보 도용</p>
            <p>2. 상업적 목적의 광고성 게시글 등록</p>
            <p>3. 다른 회원에 대한 비방·욕설·성희롱·스토킹</p>
            <p>4. 서비스를 이용한 불법 행위 및 음란물·도박 관련 콘텐츠 게시</p>
            <p>5. 서비스에서 얻은 다른 회원의 개인정보를 회사 동의 없이 상업적·외부 목적으로 이용하는 행위</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제8조 (면책)</h2>
            <p>1. 회사는 회원 간의 만남·교제·결혼 등에 대해 보증하지 않습니다.</p>
            <p>2. 천재지변·시스템 장애 등 불가항력으로 인한 서비스 중단에 대해 책임지지 않습니다.</p>
            <p>3. 회원이 자발적으로 입력한 결혼이력 등 정보의 정확성에 대한 책임은 해당 회원에게 있습니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">제9조 (약관의 변경)</h2>
            <p>회사는 관계 법령에 위배되지 않는 범위 내에서 본 약관을 개정할 수 있으며, 개정 시 시행 7일 전부터 서비스 내 공지 및 이메일을 통해 회원에게 안내합니다.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
